import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export interface IPropertyDetailOwner {
  id: number;
  name: string;
  phone: string;
  email: string;
  isConflictive: boolean;
}

export const prepareDetailPropertyOwners = (
  data: IPropertyDetailsResponse
): IPropertyDetailOwner[] => {
  return (
    data?.owners?.map(owner => ({
      id: owner.id,
      name: owner.name,
      phone: owner.mobile || owner.phone || owner.phone2 || "",
      email: owner.email,
      isConflictive: Boolean(owner.is_conflictive)
    })) || []
  );
};
